import React from 'react';
import MobilePopup from '../../../newPopup/mobilePopup/MobilePopup';
import {useTrialHandlers} from './hooks/useTrialHandlers';
import SuccessContent from './components/SuccessContent';
import * as css from './TrialPop.css';
import SendApprovalModal from '../modalContents/SendApprovalModal';
import TrialSendingPopup from '../trialSendingPopup/TrialSendingPopup';
import {convertVariablesToHtml} from '../../../textEditor/Variables';
import {useVariables} from '../../../../assets/objects/Variables';
import {useTranslation} from 'react-i18next';
import useEffectOnUpdate from '../../../../hooks/useEffectOnUpdate';
import {TrialPopProps} from './types';

const TrialPop = ({show, messageContent, contactType = 'phone', messageText, imagePath, messageType, currentLang, trialPopupShow}: TrialPopProps) => {
    const {localTrialContacts, sendApprovalShow, successShow, sendWhatsAppTemplateTrialXHR, handleTrialSend, handleActualTrialSend, handleClose} = useTrialHandlers({messageText, imagePath, messageType, currentLang, trialPopupShow, show});
    const {t: tVariables} = useTranslation('variables');
    const {t} = useTranslation('whatsapp');
    const {defaultVariables} = useVariables();  
    const processedContent = convertVariablesToHtml(messageContent, defaultVariables, tVariables);

    useEffectOnUpdate(() => {
        if(!successShow.isOpen && !sendApprovalShow.isOpen && !trialPopupShow.isOpen ) {
            handleClose();
        }
    }, [successShow.isOpen, sendApprovalShow.isOpen, trialPopupShow.isOpen]);
    return (
        <>
            <css.container>
                <MobilePopup
                    close={handleClose}
                    showClass={show.showClass}
                    title=""
                    dataCyName="trial-popup"
                    list={undefined}
                    forwardRef={undefined}
                    height={'calc(100% - 200px)'}
                    cssStyle={'width: auto;'}
                >
                    {trialPopupShow.isOpen && (
                        <TrialSendingPopup
                            show={trialPopupShow}
                            onSend={handleTrialSend}
                            contactType={contactType}
                            title={t('whatsappTrialTitle')}
                            description={t('whatsappTrialDescription')}
                            namespace={'mailing'}
                        />
                    )}
                    {sendApprovalShow.isOpen && (
                        <SendApprovalModal
                            show={sendApprovalShow}
                            amount={localTrialContacts.length}
                            messageContent={processedContent}
                            onActualSend={handleActualTrialSend}
                            XHR={sendWhatsAppTemplateTrialXHR}
                        />
                    )}
                
                </MobilePopup>
            </css.container>
            <SuccessContent
                successShow={successShow}
                localTrialContacts={localTrialContacts}
                messageContent={messageContent}
                onClose={handleClose}
            />
        </>
    );
};

export default TrialPop;
